var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.default_theme)?_c('default-input',{attrs:{"type":"number","input_props":{min: _vm.min_year, max: _vm.max_year},"value":_vm.value},on:{"change":_vm.changeYear}}):_c('search-input',{attrs:{"type":"number","min":_vm.min_year,"max":_vm.max_year,"value":_vm.value},on:{"change":_vm.changeYear}})
}
var staticRenderFns = []

export { render, staticRenderFns }